<script setup lang="ts">
defineProps<{
	title: string;
	paragraphs: string[];
}>();
</script>

<template>
	<section class="bg-white">
		<Container class="pb-11 pt-3 md:pb-20 md:pt-6">
			<slot name="breadcrumb" />
			<div
				class="flex w-full flex-col gap-6 pt-4 md:flex-row md:gap-11 md:pt-[60px]"
			>
				<div class="flex w-full flex-col gap-3 md:w-1/2">
					<h2
						class="font-matter-sq text-2xl leading-[150%] tracking-[-0.48px] text-primary lg:text-[2.75rem] lg:tracking-[-0.88px]"
					>
						{{ title }}
					</h2>
					<p
						v-for="(paragraph, index) in paragraphs"
						:key="index"
						class="self-stretch text-base font-normal leading-[24px] text-primary md:leading-[28px]"
					>
						{{ paragraph }}
					</p>
				</div>
				<div class="w-full md:w-1/2">
					<NuxtImg
						:src="'/images/about/pilar_vectors.png'"
						alt="Pilar"
						format="webp"
						width="618"
						height="320"
						placeholder
						class="object-contain"
					/>
				</div>
			</div>
		</Container>
	</section>
</template>
